@if(showMessage.emailVerificationError) {
<div>
  <h2 class="expired-message">
    This link has expired. Please try verifying your email again.
  </h2>
</div>
}

@if (showMessage.unverifiedUserError) {
<div>
  <div class="container send-again-button-container">
    <button class="send-again-button" class="btn btn-secondary" (click)="sendVerificationEmailAgain()">
      Send email again
    </button>
  </div>
  @if (showMessage.verificationEmailSuccess) {
  <p class="another-email-sent-confirmation-text">Email sent.</p>
  }
</div>
}

@if (showMessage.passwordResetSuccess) {
<div>
  <a href="/"><img class="projectzen-logo" src="/assets/projectzen_logo.jpg" alt="projectzen_logo.jpg" /></a>
  <a class="small-button position-top-right" href="login">Log In</a>
  <h2 class="subheader">Enter a new password for your account below:</h2>

  <form class="container password-reset-form">
    <div class="text-inputs">
      <input #txtPassword class="input text-input-field" type="password" name="password" required />
    </div>

    <div class="container password-reset-button-container">
      <button class="change-password-btn" class="password-reset-button" type="button"
        (click)="updatePassword(txtPassword.value)">
        Change Password
      </button>
    </div>
  </form>
  @if (showMessage.passwordChangeSuccess) {
  <p class="password-changed-confirmation">Password has been updated.</p>
  }

  <app-page-footer></app-page-footer>
</div>
}

@if(showMessage.passwordResetError) {
<div>
  <h2 class="expired-message">
    This link has expired. Please try to reset your password again.
  </h2>
</div>
}

@if (showMessage.invalidUrl) {
<div>
  <h2 class="invalid-url-message">
    This URL is invalid. Please try pasting the link again.
  </h2>
</div>
}